import { createApp } from "vue";
import App from "../App.vue";
import { router } from "@router/index";
import "@/assets/scss/main.scss";
import { createPinia } from "pinia";
import { initBiPoint } from "@biPoint/index";

initBiPoint({ dataLayerName: "officialGuideDataLayer" });
const app = createApp(App);

if ((window as any).hwerrVue) {
  app.config.errorHandler = (window as any).hwerrVue;
}
app.use(router);
app.use(createPinia());
app.mount("#app");
